import Config from 'Config';

export const statuses = {
    INACTIVE: 'INACTIVE',
    ACTIVE: 'ACTIVE',
};

export const defaultAdvancedFilterId = 501;

export const THROTTLE_WAIT_IN_MILLISECONDS = 500;

export const NO_IMAGE_FOUND_URL = `${Config.baseCDNURL}images/photoRequirements/no_photo_placeholder.svg`;

export const PORTAL_TYPES = {
    CLIENT: 'client',
    CONTRACTOR: 'contractor',
    ADMIN: 'admin',
};

// setting for pagination; default number of results to display per page
export const RESULTS_PER_PAGE = 30;

export const Z_INDEX = {
    fullscreenOverlay: 999,
    dropdownPortal: 1000,
};

export const AUTH_RETURN_TO = 'auth0_returnTo';

export const PHONE_NUMBER_TYPES = {
    MOBILE: 'mobile',
    LANDLINE: 'landline',
};
